<template>
	<section class="lightbox">
		<div class="trigger-wrapper">
			<LegacyLightboxTrigger
				class="trigger"
				v-for="(lightbox, index) in lightboxes"
				:key="index"
				@click="state = !state"
				:lightbox="lightbox"
			/>
		</div>

		<Modal
			v-model="state"
			width="680"
		>
			<div
				v-for="lightbox in lightboxes"
				class="margin-bottom-xl"
			>
				<TnHeading
					class="content-heading"
					type="h3"
					v-if="lightbox.heading"
					>{{ lightbox.heading }}
				</TnHeading>
				<RichText
					:text="lightbox.richText"
					v-if="lightbox.richText"
				/>
				<TnButton
					class="content-button"
					v-if="lightbox.button"
					v-bind="ButtonViewModel(lightbox.button)"
				></TnButton>
				<TComponent
					:component="component"
					v-for="(component, idx) in lightbox.components"
					:key="idx"
					:last="idx === lightbox.components.length - 1"
				/>
			</div>
		</Modal>
	</section>
</template>

<script>
import ButtonViewModel from "~/helpers/ViewModels/ButtonViewModel.js";

export default defineNuxtComponent({
	name: "LegacyLightboxAdapter",

	props: {
		lightboxes: Array,
	},

	data() {
		return {
			state: false,
			swipedToLeft: false,
			currentIndex: -1,
			showBox: false,
			dimmedBackdrop: "dimmed-backdrop",
			hideArrows: false,
		};
	},

	methods: {
		ButtonViewModel,
	},
});
</script>

<style lang="scss" scoped>
.lightbox {
	.trigger-wrapper {
		display: flex;
		flex-wrap: wrap;
		justify-items: center;
		justify-content: space-between;
		width: 100%;

		@include breakpoint(mobile) {
			flex-wrap: nowrap;
			justify-content: unset;
			overflow-x: scroll;
			width: 100%;
			padding-bottom: 1rem;

			&::-webkit-scrollbar {
				width: 5px;
				height: 4px;
			}

			&::-webkit-scrollbar-track {
				background-color: $color-background-grey;
				height: 4px;
			}

			&::-webkit-scrollbar-thumb {
				background-color: $color-background-dark;
				width: 30px !important;
			}

			&.yng {
				&::-webkit-scrollbar-thumb {
					background-color: $color-background-dark;
					width: 30px !important;
				}
			}
		}
	}
}
</style>
